export default "__VITE_ASSET__CPDFN8Nd__"